import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'
import AudioDedup from '@/views/AudioDedup.vue'
import HotSale from '@/views/HotSale.vue'
import SmartOverlay from '@/views/SmartOverlay.vue'
import LiveFloat from '@/views/LiveFloat.vue'
import DynamicTitle from '@/views/DynamicTitle.vue'
import AuthPage from '@/views/AuthPage.vue'

Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/login',
    name: 'auth',
    component: AuthPage
  },
  {
    path: '/register',
    name: 'register',
    component: AuthPage
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: AuthPage
  },
  {
    path: '/audio',
    name: 'audio-dedup',
    component: AudioDedup,
  },

  {
    path: '/hot-sale',
    name: 'hot-sale',
    component: HotSale,
  },
  {
    path: '/smart-overlay',
    name: 'smart-overlay',
    component: SmartOverlay,
  },
  {
    path: '/live-float',
    name: 'live-float',
    component: LiveFloat,
  },
  {
    path: '/dynamic-title',
    name: 'dynamic-title',
    component: DynamicTitle,
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
